import { render } from "./Index.vue?vue&type=template&id=b6f6e9ba"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__